(function () {
  angular.module('MktzapApp.Controllers')
    .controller('HsmController', hsm);

  hsm.$inject = ['$rootScope', 'FoundationApi', 'HsmCrudService', 'NotificationService', 'ngTableParams', 'CompanyService'];

  function hsm ($rootScope, FoundationApi, HsmCrudService, NotificationService, ngTableParams, CompanyService) {
    var vm = this;
    vm.filters = {}
    vm.metadata = {}
    vm.hsms = {}
    vm.languages = {}
    vm.hsmTable = new ngTableParams({
	        count: 50
	    }, {
	    	counts: [25, 50, 100],
	        getData: function ($defer, params) {
	        	var obj = params.url();
        var keys = Object.keys(vm.filters);
        for (var i = 0; i < keys.length; i++) {
          var filterValue = vm.filters[keys[i]];
          if (filterValue != null && filterValue !== '') {
            obj['filter[' + keys[i] + ']'] = filterValue;
          }
        }

	        	HsmCrudService
	        	.paged(obj)
	        	.$promise
	        	.then(function (data) {
        			params.total(data.total);
            $defer.resolve(data.data);
            vm.data_total = data.total;
            vm.data_result = data.data.length;
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'não foi possível listar os HSMs.');
          });
	        }
	    });
	    CompanyService.findForChannel({
      type: 'hsm'
    }, function (data) {
      vm.company = data;

      if (!vm.hsms) {
        vm.hsms = {};
        vm.hsms.company_id = vm.company.id;
      }
      if (vm.company.metadata !== undefined && vm.company.metadata !== null) {
        for (var i in vm.company.metadata) {
          if (typeof vm.company.metadata[i]['value'] === 'string') {
            vm.metadata[vm.company.metadata[i]['key']] = JSON.parse(vm.company.metadata[i]['value']);
          } else {
            vm.metadata[vm.company.metadata[i]['key']] = vm.company.metadata[i]['value'];
          }
        }
      }
    });

    function loadDefaultHSMNamespace () {
      if (!$rootScope.company_metadata.allow.managerCreateHSM) {
        return ''
      }
      return CompanyService.loadMetadataKey({
        key: 'hsm'
      })
        .$promise
        .then(function (data) {
          try {
            const companyMetadata = JSON.parse(data.value)
            return companyMetadata.default_namespace || ''
          } catch (e) {
            return ''
          }
        })
    }

    getHsmLanguage()

    function getHsmLanguage () {
      HsmCrudService
        .getHsmLanguage()
        .$promise
        .then(function (data) {
          if (data.language) {
            vm.languages = data.language
          } else {
            NotificationService.errorHandler(data, 'Erro ao carregar language!')
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro durante a comunicação com banco de dados!')
        })
    }

    vm.addHsm = async function () {
      const defaultHSMNamespace = await loadDefaultHSMNamespace()
      vm.hsms = {
        name: '',
        element_name: '',
        company_id: $rootScope.user_data.company_id,
        policy: 'deterministic',
        language: '',
        namespace: defaultHSMNamespace,
        template: ''
      }
      FoundationApi.publish('addHsmModal', 'open')
    }

    vm.editHsm = function (hsmId) {
      HsmCrudService
        .findOne({ id: hsmId })
        .$promise
        .then(function (data) {
          vm.hsms = data;
          FoundationApi.publish('addHsmModal', 'open');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao processar requisição, por favor tente novamente.');
        });
    }

    function validateHsm (hsm) {
      if (!hsm.name || !hsm.namespace || !hsm.template || !hsm.element_name || !hsm.language) {
        NotificationService.errorHandler(null, $rootScope.labels.requiredFieldsError)
        return false
      }
      return true
    }
    vm.saveHsm = function (hsm) {
      if (!validateHsm(hsm)) {
        return false;
      }
      vm.hsms = hsm
      if (vm.hsms.id === undefined) {
        HsmCrudService
          .create({}, hsm)
          .$promise
          .then(function (data) {
            vm.hsms = data
            vm.hsmTable.reload()
            NotificationService.successHandler(data, 'Os dados foram criados com sucesso!');
            FoundationApi.publish('addHsmModal', 'close');
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, 'Erro ao processar requisição, por favor tente novamente.');
          });
      } else {
        HsmCrudService
          .update({ id: vm.hsms.id }, hsm)
          .$promise
          .then(function (data) {
            vm.hsms = data
            vm.hsmTable.reload()
            NotificationService.successHandler(data, 'Os dados foram atualizados com sucesso!');
            FoundationApi.publish('addHsmModal', 'close');
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, 'Erro ao processar requisição, por favor tente novamente.');
          });
      }
    }

    vm.deleteHsm = function (hsm, index) {
      FoundationApi.publish('confirmDeleteModal', 'close');

      HsmCrudService.delete({
        id: vm.deleting.id
      }, function (data) {
        vm.hsmTable.reload()
        NotificationService.successHandler(data, 'Os dados foram removidos com sucesso!');
      });
    }

    vm.confirmDelete = function (hsm) {
      vm.deleting = hsm
      FoundationApi.publish('confirmDeleteModal', 'open');
    }
  }
})();
